<template>
  <div class="zj-form-container">
    <div id="qrcode"></div>
  </div>
</template>



<script>
import QRCode from 'qrcodejs2' 
import WebApis from "../../../apis";

export default {
  name: "QRCodePage",
  data() {
    
    return {
      
    };
  },
  props: {
    Business_Code: {
      type: String,
      default: "",
    },
    ChildBusiness_Code: {
      type: String,
      default: "",
    }
  },
  created: function () {
    this.qrcode();
  },
  computed: {

  },
  methods: {
    // 初始化
    qrcode () {  

        let ChildBusinessSearch={
            BusinessCode:this.Business_Code,
            ChildBusinessCode:this.ChildBusiness_Code
        }

       return new WebApis.ChildBusinessApi().GetQRCode(ChildBusinessSearch).then((res)=>{
        console.log(res);
         if (res.data.Data) {
                var url=res.data.Data;

               let qr=  new QRCode('qrcode', {  
                    width: 300,  
                    height: 300, // 高度  
                    text: url // 二维码内容  
                    // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）  
                    // background: '#f0f'  
                    // foreground: '#ff0'  
                })  ;

                console.log("qr",qr);
            }
      });

    
    }  
  }
};
</script>
